import { ReactNode } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

interface DrawerProps {
  isOpen: boolean
  isMobile: boolean
  sidebarWidth: number
  children: ReactNode
}

export const Drawer = ({ isOpen, isMobile, sidebarWidth, children }: DrawerProps) => {
  const style = isMobile
    ? {
        width: '100%',
        height: '50%',
        left: '0',
        bottom: '0',
        transform: `translate3d(0, ${isOpen ? '0' : 'calc(100% + 100px)'}, 0)`,
        transition: 'transform 0.5s ease-in-out',
        willChange: 'transform',
        zIndex: '10',
      }
    : {
        width: `${sidebarWidth}px`,
        height: '100%',
        right: '0',
        top: '0',
        transform: `translate3d(${isOpen ? '0' : `${sidebarWidth + 100}px`}, 0, 0)`,
        transition: 'transform 0.5s ease-in-out',
        willChange: 'transform',
        zIndex: '10',
      }

  return (
    <Box
      style={style}
      position="absolute"
      paddingBottom="s16"
      paddingTop={isMobile ? 's0' : 's16'}
      paddingLeft={isMobile ? 's24' : 's0'}
      paddingRight="s24"
    >
      <Box
        background="grey000White"
        flexDirection="column"
        boxShadow="s50"
        borderRadius={{ all: 'abs016' }}
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: 'grey200',
          },
        }}
        height="full"
      >
        {children}
      </Box>
    </Box>
  )
}
